import React from 'react';

export default {
  carouselHome: {
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 600,
    adaptiveHeight: true,
    infinite: true,
    lazyLoad: true,
    dots: true,
    draggable: true,
    autoplay: true,
    autoplaySpeed: 3000,
    prevArrow: <span className="glyphicon glyphicon-menu-left" />,
    nextArrow: <span className="glyphicon glyphicon-menu-right" />,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          dots: false,
        },
      },
    ],
  },
  carouselProductDetail: {
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 700,
    adaptiveHeight: false,
    infinite: true,
    lazyLoad: true,
    dots: true,
    draggable: true,
    autoplay: false,
    autoplaySpeed: 3000,
    centerMode: true,
    centerPadding: 0,
    prevArrow: <span className="icon-arrow-left-light" />,
    nextArrow: <span className="icon-arrow-right-light" />,
  },
  articlesDetailPage: {
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 600,
    adaptiveHeight: false,
    lazyLoad: true,
    infinite: false,
    dots: false,
    draggable: true,
    autoplay: false,
    prevArrow: <span className="icon-arrow-left-light" />,
    nextArrow: <span className="icon-arrow-right-light" />,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  },
  jamieCollectionPDP: {
    arrows: true,
    slidesToShow: 3.2,
    slidesToScroll: 1,
    speed: 600,
    adaptiveHeight: false,
    infinite: false,
    lazyLoad: false,
    dots: false,
    draggable: true,
    autoplay: false,
    autoplaySpeed: 3000,
    variableWidth: false,
    prevArrow: <span className="glyphicon glyphicon-menu-left" />,
    nextArrow: <span className="glyphicon glyphicon-menu-right" />,
    accessibility: true,
    responsive: [
      {
        breakpoint: 896,
        settings: {
          dots: false,
          arrows: true,
          draggable: true,
          autoplay: false,
          infinite: false,
          slidesToShow: 3.1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 769,
        settings: {
          dots: false,
          arrows: true,
          draggable: true,
          autoplay: false,
          infinite: false,
          slidesToShow: 2.2,
          slidesToScroll: 1,
        
        },
      },
      {
        breakpoint: 435,
        settings: {
          dots: false,
          arrows: true,
          draggable: true,
          autoplay: false,
          infinite: false,
          slidesToShow: 1.2,
          slidesToScroll: 1,
          
        },
      },
    ],
  },
  "Video Banner":
    {
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 600,
      adaptiveHeight: false,
      infinite: true,
      lazyLoad: false,
      dots: true,
      draggable: true,
      autoplay: false,
      autoplaySpeed: 7000,
      prevArrow: <span className='glyphicon glyphicon-menu-left' />,
      nextArrow: <span className='glyphicon glyphicon-menu-right' />,
      responsive: [
          {
              breakpoint: 1025,
              settings: {
                  dots: true,
                  arrows: false,
                  draggable: true,
                  autoplay: true,
                  infinite: true,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  initialSlide: 0
              }
          }
      ]
  },

   "Image Banner":
    {
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 600,
      adaptiveHeight: false,
      infinite: false,
      lazyLoad: false,
      dots: false,
      draggable: true,
      autoplay: false,
      autoplaySpeed: 7000,
      prevArrow: <span className='glyphicon glyphicon-menu-left' />,
      nextArrow: <span className='glyphicon glyphicon-menu-right' />,
      responsive: [
          {
              breakpoint: 1025,
              settings: {
                  dots: false,
                  arrows: true,
                  draggable: true,
                  autoplay: false,
                  infinite: false,
                  slidesToShow: 1,
                  slidesToScroll: 1,
              }
          }
      ]
  },
  
  'video-carousel': {
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 600,
    adaptiveHeight: false,
    infinite: false,
    lazyLoad: false,
    dots: true,
    draggable: true,
    autoplay: false,
    autoplaySpeed: 3000,
    prevArrow: <span className="glyphicon glyphicon-menu-left" />,
    nextArrow: <span className="glyphicon glyphicon-menu-right" />,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          dots: true,
          draggable: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          autoplay: false,
        },
      },
    ],
  },
  'instagram-carousel': {
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 600,
    adaptiveHeight: true,
    infinite: false,
    lazyLoad: true,
    dots: true,
    draggable: true,
    autoplay: false,
    autoplaySpeed: 3000,
    prevArrow: <span className="glyphicon glyphicon-menu-left" />,
    nextArrow: <span className="glyphicon glyphicon-menu-right" />,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: true,
          draggable: true,
          slidesToShow: 2,
          slidesToScroll: 1,
          autoplay: false,
          arrows: false,
          verticalSwipping: false,
        },
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 3,
          dots: true,
          arrows: false,
          draggable: true,
          autoplay: false,
        },
      },
    ],
  },
};
